<template>
  <section class="section" :class="modifiers" @scroll.passive="checkScroll">
    <div class="section__inner">
      <div v-if="$slots.header" class="section__header">
        <div class="app__layout">
          <slot name="header" />
        </div>
      </div>
      <div v-if="$slots.content" class="section__content">
        <div class="app__layout">
          <slot name="content" />
        </div>
      </div>
    </div>
    <BaseButton
      v-if="withDownButton && isDownButtonVisible"
      is-bright
      class="section__down"
      data-animation="fadeInBottom"
      @click="scrollDown"
    >
      <BaseIcon name="arrow_right" class="section__down-arrow" />
    </BaseButton>
    <slot />
  </section>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseSection',
  components: {
    BaseButton,
    BaseIcon,
  },
  props: {
    withDownButton: {
      type: Boolean,
      default: true,
    },
    isWide: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDownButtonVisible: true,
    };
  },
  computed: {
    modifiers() {
      return {
        section_wide: this.isWide,
        section_down: this.isDownButtonVisible,
        [`section_bg_${this.bg}`]: Boolean(this.bg),
      };
    },
  },
  mounted() {
    this.checkScroll();
  },
  methods: {
    scrollDown() {
      const { scrollTop } = this.$el;
      this.$el.scrollTo({
        top: scrollTop + (window.innerHeight - 80),
        behavior: 'smooth',
      });
    },
    checkScroll() {
      const { scrollTop, scrollHeight } = this.$el;
      this.isDownButtonVisible = scrollTop + window.innerHeight < scrollHeight - 70;
    },
  },
};
</script>

<style lang="stylus">
@keyframes slide-out
  0%
    transform translate3d(0%, 0, 0)
  100%
    transform translate3d(-50%, 0, 0)

@keyframes slide-out-back
  0%
    transform translate3d(0%, 0, 0)
  100%
    transform translate3d(50%, 0, 0)

@keyframes slide-in
  0%
    transform translate3d(100%, 0, 0)
  100%
    transform translate3d(0%, 0, 0)

@keyframes slide-in-back
  0%
    transform translate3d(-100%, 0, 0)
  100%
    transform translate3d(0%, 0, 0)

.section
  display block
  // overflow-y auto
  // height calc(100% - 2em)
  width 100%
  height 100%
  overflow-y auto
  overflow-x hidden
  background-color #fff
  +landscape()
    background-color #f9f9f9
    &_bg_covid
      background-image url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='%23f3f3f3' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.5 17C8.467 17 6 14.533 6 11.5S8.467 6 11.5 6 17 8.467 17 11.5 14.533 17 11.5 17zM10 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2h.01zm0 0h.01zm0 0h.01zm0 0h.01zm0 0h.01zm0-.001h.01zm0 0h.01zM3 9c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2h.01zm0 0h.01zm0 0h.01zm0 0h.01zm0 0h.01zm0-.001h.01zm0 0h.01zM2.5 20C1.122 20 0 18.878 0 17.5S1.122 15 2.5 15 5 16.122 5 17.5 3.878 20 2.5 20zM21 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM20.5 24c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zM10.5 5C9.122 5 8 3.878 8 2.5S9.122 0 10.5 0 13 1.122 13 2.5 11.878 5 10.5 5z'/%3E%3Cpath d='M17.673 19.087l-3.34-3.34a.999.999 0 111.414-1.414l3.34 3.34a.999.999 0 11-1.414 1.414zM14.474 8.836a1 1 0 01.08-1.412l3.92-3.5a1 1 0 111.332 1.492l-3.92 3.5a1 1 0 01-1.412-.08zM9.22 20.379l.58-4.08a1 1 0 111.981.281l-.58 4.08c-.19 1.326-2.167 1.027-1.981-.281zM9.956 6.649l-.28-2.56a1 1 0 111.988-.218l.28 2.56a1 1 0 11-1.988.218zM3.337 16.944a1.001 1.001 0 01.278-1.387l3.17-2.11a1 1 0 111.109 1.665l-3.17 2.11a1 1 0 01-1.387-.278zM6.612 10.044l-2.76-1.46a1 1 0 01.936-1.768l2.76 1.46a1 1 0 01-.936 1.768z'/%3E%3C/svg%3E")
      background-position 140% 140%
      background-size 75% 75%
      background-repeat no-repeat

  // +landscape()
  //   scrollbar-color transparent transparent
  //   scrollbar-width thin
  //   // overflow-y auto
  //   overflow-y scroll
  //   width calc(100% + 11px)
  //   ///margin-right -101px

  //   &::-webkit-scrollbar
  //     background-color transparent
  //     width 11px
  //     height @width

  //   &::-webkit-scrollbar-thumb
  //     border: solid 3px transparent
  //     background-color transparent
  //     background-clip padding-box
  //     border-radius 11px

  //   &:hover
  //     scrollbar-color alpha($c_dim, 50%) transparent
  //     &::-webkit-scrollbar-thumb
  //       background-color alpha($c_dim, 50%)

  &-slide-leave-active
    animation slide-out 600ms cubic-bezier(0.83, 0, 0.17, 1) both
    .app_back_move &
      animation-name slide-out-back

  &-slide-enter-active
    animation slide-in 600ms cubic-bezier(0.83, 0, 0.17, 1) both
    .app_back_move &
      animation-name slide-in-back

  &-slide-enter-active
  &-slide-leave-active
    abs top left right bottom
    overflow hidden
    *
      animation-play-state paused !important

  // &__content
  //   padding 40px 0
  //   background-color #fff

  &__inner
    width 100%
    min-height 100%
    display flex
    flex-direction column
    +landscape()
      padding-top 3.5em
      padding-bottom @padding-top + 5em
      //padding-top 5em
      //padding-bottom @padding-top
    // padding-top 5em
    // +ie11()
    //   flex-direction row
    //   flex-wrap wrap
    //   height 100%

  &__header
  &__content
    +portrait()
      padding-top 2em
      padding-bottom 2em
      &:first-child
        padding-top 3em + @padding-top//8em//calc(124px + 2em)
        // background-color red
    // +landscape()
    //   max-width 40em
    //   margin 0 auto

  &__header
    +portrait()
      // padding 2em 0//40px 0
      background $c_bg
      border-radius 0 0 1.25em 1.25em
      // &:first-child
      //   padding-top calc(124px + 2em)
    +landscape()
      padding-bottom 1.5em

  &__content
    +portrait()
      flex 1 0 auto
      min-height 0
      padding-bottom 7em
    // +landscape()
    //   padding-top 4em
    //   padding-bottom @padding-top
    // +landscape()
    //   padding-bottom 4em
    // padding 2em 0//40px 0
    // &:first-child
    //   padding-top calc(124px + 2em)

  // &__layout
  //   max-width 35em
  //   margin 0 auto

  &__row
    +landscape()
      display flex
      flex-flow row wrap

  &__col
    +landscape()
      flex-grow 1
      flex-basis 0
      max-width 100%
      &_middle
        align-self center
      &_banner
        order -1
        padding-right 2.5em
        max-width 28%
        padding-bottom 0.7em
      // &_video
      //   max-width 88vh
    +portrait()
      margin-top 1.3em
      &:first-child
        margin-top 0

  &__title.title
    margin-bottom 0.4em

  &__gap
    margin-top 1.3em//2em//2.2em
    &_double
      margin-top @margin-top * 2

  &__offset
    +portrait()
      margin-left -1.4em
      margin-right @margin-left
    // +landscape()
    //   margin-left -2em
    //   margin-right @margin-left
    // padding-left 1.4em
    // padding-right @padding-left

  &__history
    +portrait()
      margin-left -1.4em
      margin-right @margin-left
    +landscape()
      // background-color red
      margin-left calc((100vw - 48em) / 2 * -1)//-1.4em
      margin-right calc((100vw - 48em) / 2 * -1)
      .history__items
        padding-left calc((100vw - 48em) / 2)
        &:after
          flex 0 0 calc((100vw - 48em) / 2)

  &__cards
    // +portrait()
    //   .card + .card
    //     margin-top 1em
    +landscape()
      display flex
      flex-wrap wrap
      justify-content space-between
      // .card
      //   flex 0 0 50%
      //   max-width calc(50% - 0.5em)
      //   &:not(:nth-child(-n+2))
      //     margin-top 1em

  &__card
    +landscape()
      flex 0 0 50%
      max-width calc(50% - 0.5em)
      &:not(:nth-child(-n+2))
        margin-top 1em
    +portrait()
      & + &
        margin-top 1em

  &__reviews
    +landscape()
      column-count 2
      column-gap 1.5em

  &__review
    +portrait()
      & + &
        margin-top 1em
    +landscape()
      display inline-block
      vertical-align top
      margin-bottom 1.5em
      break-inside avoid
  // &__actions
  //   abs bottom left right
  //   display flex
  //   //justify-content space-between
  //   padding-bottom 2em

  // &__action
  //   &_next
  //     &.button
  //       margin-left auto
  //   &_prev
  //     &.button
  //       margin-right auto
  //   &.button
  //     flex 0 0 50%
  //     max-width 47%
  //     padding 0

  &__button
    width 100%

  &__down
    fix bottom right
    width 3em
    height @width
    padding 0.85em
    margin 0.5em
    border-radius @width
    z-index 10
    +landscape()
      margin-bottom 6.5em
      margin-right 1.5em
      .section-slide-leave-active &
        display none

  &__down-arrow
    display block
    width 100%
    height 100%
    transform rotate(90deg)

  &__logo
    display block
    width 60%
    +landscape()
      margin-left auto
      margin-right 4em

  &__form
    +landscape()
      max-width 22em
</style>
